<template>
  <div>
    <div v-if="unionFlag">
      <img :src="require('@assets/images/coupon_usetTip.png')" />
      <p class="title">
        <span>{{ TLang("couponTips", "orderConfirm") }}</span>
      </p>
      <p class="subTitle">
        <span>{{ TLang("scanCode", "orderConfirm") }}！</span>
      </p>
      <div>
        <div
          class="steps"
          v-html="TLang('scanCodeTips1', 'orderConfirm')"
        ></div>
      </div>
      <div class="stepOne">
        <ul>
          <li>·{{ TLang("scanCodeTips2", "orderConfirm") }}</li>
          <li>·{{ TLang("scanCodeTips3", "orderConfirm") }}</li>
          <li>·{{ TLang("scanCodeTips4", "orderConfirm") }}</li>
        </ul>
      </div>
      <!-- <img class="stepTwo" :src="require('@assets/images/MiniApps.png')" /> -->
      <img class="stepTwo" :src="qrcodeImg" />
      <img class="stepThree" :src="require('@assets/images/stepThree.png')" />
    </div>
    <div v-else>
      <img :src="require('@assets/images/coupon_usetTip.png')" />
      <p class="title">
        <span>{{ TLang("scanCodeTips5", "orderConfirm") }}</span>
      </p>
      <p class="subTitle">
        <span>{{ TLang("scanCodeTips6", "orderConfirm") }}</span>
      </p>
      <div>
        <div class="steps">
          <span style="width: 34%">{{
            TLang("scanCodeTips7", "orderConfirm")
          }}</span
          ><span style="width: 28%">{{
            TLang("scanCodeTips8", "orderConfirm")
          }}</span
          ><span style="width: 37%">{{
            TLang("scanCodeTips9", "orderConfirm")
          }}</span>
        </div>
      </div>
      <div class="stepOne">
        <img v-if="!unionFlag" :src="require('@assets/images/stepOne.png')" />
      </div>
      <!-- <img class="stepTwo" :src="require('@assets/images/MiniApps.png')" /> -->
      <img class="stepTwo" :src="qrcodeImg" />
      <img class="stepThree" :src="require('@assets/images/stepThree.png')" />
    </div>
  </div>
</template>

<script>
import { unionFlag } from "@utils/index";
export default {
  name: "CouponTip",
  props: {
    qrcodeImg: String,
  },
  data() {
    return {
      unionFlag: unionFlag(),
    };
  },
};
</script>

<style lang="less">
.title {
  position: absolute;
  top: 26px;
  left: 28px;
  font-size: 20px;

  font-weight: bold;
  color: #333333;
}
.subTitle {
  position: absolute;
  top: 64px;
  left: 28px;
  text-align: left;
  font-size: 16px;

  color: #666666;
}
.steps {
  width: 100%;
  text-align: left;
  position: absolute;
  top: 193px;
  left: 0;
  font-size: 14px;

  font-weight: 400;
  color: #333333;
  span {
    display: inline-block;
    text-align: center;
  }
}
.stepOne {
  width: 163px;
  position: absolute;
  top: 236px;
  left: 36px;
  text-align: left;
  img {
    width: 100%;
    display: block;
  }
  li {
    font-size: 14px;
  
    color: #666;
    line-height: 20px;
    margin-bottom: 20px;
  }
}
.stepTwo {
  width: 150px;
  position: absolute;
  top: 236px;
  left: 275px;
}
.stepThree {
  width: 163px;
  position: absolute;
  top: 236px;
  right: 56px;
}
</style>
